import logout from 'core/axios/logout';

import { ensureObject } from 'utils/objects';

const UNAUTHORIZED = 401;

const addUnauthorizedInterceptor = client => {
  // intercept responses to see whether the user is unauthorized, and if so, log them out
  client.interceptors.response.use(
    response => response,
    error => {
      const { response } = error;

      if (ensureObject(response).status === UNAUTHORIZED) {
        logout();
      }

      return Promise.reject(error);
    },
  );
};

export default addUnauthorizedInterceptor;
